async function submitForm(endpoint, oid, inputs, sf, map) {
  const formData = [];
  formData.push({ key: 'oid', value: oid })
  formData.push({ key: 'retUrl', value: '' })
  formData.push({ key: 'first_name', value: String(inputs.first_name?.value) })
  formData.push({ key: 'last_name', value: String(inputs.last_name?.value) })
  formData.push({ key: 'email', value: String(inputs.email?.value) })

  if (map === 'subscribe') {
    const [checkbox, checkboxes] = inputs.signup

    checkboxes.forEach(cb => {
      const textId = cb.id.replace('__Selected', '__Text')
      const key = document.querySelector(`#${textId}`).value.toLowerCase()
      formData.push({ key: sf[key.replace(' ', '')], value: true })
    })

    formData.push({ key: sf.expressed_interest, value: 'Additional Account'  })
    formData.push({ key: sf.product_line, value: 'Deposit' })
    formData.push({ key: sf.product_enquiry, value: 'Spendwise' })

    formData.push({ key: 'phone', value: '1234567890'})
    formData.push({ key: sf.branch, value: 'Lagimodiere'})
    formData.push({ key: sf.comment, value: 'Marketing Use for subscription enrollment in FSC'})

  } else if (map === 'personal' || map === 'business') {

    if (map === 'personal') {
      formData.push({ key: sf.personal, value: true })
    } else {
      formData.push({ key: sf.business, value: true })
      formData.push({ key: sf.business_name, value: String(inputs.business_name?.value) })
    }

    formData.push({ key: sf.expressed_interest, value: String(inputs.expressed_interest?.value) })
    formData.push({ key: sf.product_line, value: String(inputs.product_line?.value) })
    formData.push({ key: sf.product_enquiry, value: String(inputs.product_enquiry?.value) })

    formData.push({ key: 'phone', value: inputs.phone?.value.replace(/\D/g,'') })
    formData.push({ key: sf.branch, value: inputs.branch?.value.split(":")[0] })
    formData.push({ key: sf.comment, value: String(inputs.comment?.value) })
  }

  // Defaults
  formData.push({ key: 'lead_source', value: 'Website'})
  formData.push({ key: sf.status, value: 'Non-Member'})
  formData.push({ key: sf.referrer, value: 'Website'})
  formData.push({ key: sf.contact, value: 'Email'})

  await submitFormData(
    endpoint,
    formData
  )
}

async function submitFormData(url, data) {
  try {
    let formBody = [];

    // Turning the form data into a URL-encoded string for submission
    data.forEach(function (arrayItem) {
      const encodedKey = encodeURIComponent(arrayItem.key);
      const encodedValue = encodeURIComponent(arrayItem.value);
      formBody.push(encodedKey + "=" + encodedValue);
    });
    formBody = formBody.join("&");

    const response = await fetch(`${url}&${formBody}`, {
      method: 'POST',
      mode: 'no-cors'
    });

    // Since mode: 'no-cors', you cannot do much with the response,
    // So skipping response.json() and we just cross our fingers and hope for the best
  } catch (error) {
    console.log('Error during fetch');
    console.log(error);
  }
}

export { submitForm }
